import React from "react";
import Layout from "../../Layout";
import HeaderUser from "../HeaderUser";
import { Link } from "react-router-dom";

const SuccessRegistration = () => (
  <Layout>
    <HeaderUser />
    <main className="layout-container">
      <div className="container ctr">
        <div className="bi-success-check" aria-hidden="true">
          <i className="bi bi-check2-circle" aria-hidden="true"></i>
        </div>
        <h1 
            className="lg-msg" 
            role="status"
            aria-live="polite"
         >
          User has been added successfully.
        </h1>
        <div className="text-size6 spacer-margin3">
          An email has been sent to the contact address with the new username and a temporary password. To register additional users, click the button below to return to the registration page.
        </div>
        <Link
          to={"/user-registration"}
          className="btn btn-primary"
        >
          Add Users
        </Link>
      </div>
      </main>
    </Layout>
);

export default SuccessRegistration;
